import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import {
  CalibrationConfirmInvoiceApiResponse,
  CalibrationConfirmInvoiceModel
} from 'src/app/Interface/CalibrationConfirmInvoice_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationConfirmInvoiceService } from 'src/app/Service/CalibrationConfirmInvoice.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-calibration-confirm-invoice',
  templateUrl: './CalibrationConfirmInvoice.component.html',
  styleUrls: ['./CalibrationConfirmInvoice.component.scss']
})
export class CalibrationConfirmInvoiceComponent implements OnInit {
  loading = false;
  confirmingId: number | null = null;
  page = 0;
  list: CalibrationConfirmInvoiceModel[] = [];
  selectedConfirmReceipt: CalibrationConfirmInvoiceModel | null = null;
  selectedConfirmReceiptDone = "1";
  confirmModalRef: any;
  Filter_title: any;

  constructor(
    private service: CalibrationConfirmInvoiceService,
    private alertifyService: AlertifyService,
    private modalService: BsModalService,
    private Nav_Service: NavService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.Nav_Service.CheckValidPage(2242).subscribe(
      data => {
        this.getList();
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }

  Change_Filter_title() {
    this.page = 0
  }


  getList(): void {
    this.loading = true;
    this.service.GetPending(this.selectedConfirmReceiptDone == "1")
      .pipe(finalize(() => this.loading = false))
      .subscribe(
        response => this.list = this.unwrap(response),
        () => this.alertifyService.ErrorMessage('دریافت لیست رسیدهای آماده تایید با خطا مواجه شد.')
      );
  }

  showDetail(item: CalibrationConfirmInvoiceModel): void {
    this.router.navigate(
      ['/CalibrationConfirmInvoiceForm', { id: item.calibrationId }],
      { state: { receipt: item } }
    );
  }

  openConfirmModal(template: TemplateRef<any>, item: CalibrationConfirmInvoiceModel): void {
    if (item.confirmedDeviceCount !== item.totalDeviceCount) {
      this.alertifyService.ErrorMessage('ابتدا تمام تجهیزات رسید تایید کار شوند');
      return;
    }

    this.selectedConfirmReceipt = item;
    this.confirmModalRef = this.modalService.show(template);
  }

  confirm(): void {
    if (!this.selectedConfirmReceipt || this.confirmingId !== null) {
      return;
    }

    if (this.selectedConfirmReceipt.confirmedDeviceCount !== this.selectedConfirmReceipt.totalDeviceCount) {
      this.alertifyService.ErrorMessage('ابتدا تمام تجهیزات رسید تایید کار شوند');
      return;
    }

    const id = this.selectedConfirmReceipt.calibrationId;
    this.confirmModalRef.hide();
    this.confirmingId = id;
    this.service.Confirm(id)
      .pipe(finalize(() => this.confirmingId = null))
      .subscribe(
        () => {
          this.alertifyService.SuccessMessage('رسید و پیش فاکتور با موفقیت تایید شد.');
          this.list = this.list.filter(item => item.calibrationId !== id);
          this.getList();
        },
        () => this.alertifyService.ErrorMessage('تایید نهایی با خطا مواجه شد.')
      );
  }

  private unwrap<T>(response: T[] | CalibrationConfirmInvoiceApiResponse<T[]>): T[] {
    if (Array.isArray(response)) {
      return response;
    }
    return response && Array.isArray(response.result) ? response.result : [];
  }
}
